:host {
  display: block;
}

.header-top {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAABGCAIAAABpHdIJAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4ZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTExIDc5LjE1ODMyNSwgMjAxNS8wOS8xMC0wMToxMDoyMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDowZjBlYWYxYS1lY2ViLTRmZGUtOGJiYi01Nzc0MjhmZDc1M2YiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MTYxMjg0NzRDOEZDMTFFNUI1QkY5MDk4NjQwMjE1M0QiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MTYxMjg0NzNDOEZDMTFFNUI1QkY5MDk4NjQwMjE1M0QiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpmMmUyNDkyYy03Y2RiLTRhZTYtOGZjMy0wY2E3MTkwYjBjMDAiIHN0UmVmOmRvY3VtZW50SUQ9ImFkb2JlOmRvY2lkOnBob3Rvc2hvcDphNjU2ZjhlZS1kMzY0LTExNzgtODhjNi1mMTA3MzAzZGQ1OTkiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz62retYAAAAYklEQVR42oyQQQ6AIAwEV9KLX/Ef/v9JI2A1aEoDBzYsLUx3249TkklUKerrKyYYT3dl9XCTuN1N6/u/PXp6VpLcRT8QsqD5mA0CH6WMJWRJhEhvICzmmVEvwT+SUTe5BBgA6OYtCGFP9zkAAAAASUVORK5CYII=);
  background-size: contain;
  padding: 10px 0 3px;
  background: var(--blue-logo-gradient);
  /* min-height: 60px; */
}

.header-top img.default-logo {
  width: 290px;
  padding: 10px 0;
}
.header-top img.alt-logo {
  width: 290px;
  padding: 10px 0;
}

.header {
  background: linear-gradient(to right, #003071 35%, #09143a 80%);
  padding: 20px 0 20px;
}

.header .cwru-center {
  position: relative;
}

.site-name > * {
  color: #fff;
  font-size: 40px;
  font-weight: var(--font-weight-thin);
  margin: 0;
  text-decoration: none;
  font-family: var(--font-text);
}

.department-name {
  margin-bottom: calc(var(--s2) * -1);
  padding-bottom: 50px;
  padding-top: 5px;
}

.department-name > * {
  display: inline-block;
  color: #fff;
  /* background-color: #888; */
  /* padding: var(--s-2) var(--s-1); */
  font-size: var(--s1);
  font-weight: var(--font-weight-normal);
  margin: 0;
  /* margin-top: 5px; */
  font-family: var(--font-text);
}

.site-name a,
.department-name a {
  color: #fff;
  text-decoration: none;
  font-family: var(--font-text);
}

.department-name a {
  font-size: 28px;
  font-weight: 400;
  padding-top: 10px;
}

.site-name a {
  line-height: 1.15;
  font-weight: 200;
  font-size: 40px;
}

.search-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  /* margin-top: 25px; */
}

.search-form {
  display: none;
  position: relative;
}

.search-input {
  outline: none;
  border: var(--border-thin) solid var(--color-light-gray);
  border-radius: 999px;
  font-size: var(--s-1);
  font-style: italic;
  font-weight: var(--font-weight-bold);
  padding: var(--s-3) var(--s-2);
  width: 230px;
  transition: width 0.2s ease;
  background: var(--color-white);
}
.search-input:focus {
  width: 270px;
}

.search-button {
  background-color: transparent;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 13px;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 30px;
  border: 0;
  outline: 0;
  z-index: 5;
  cursor: pointer;
}

.hidden {
  display: none;
}

@media (min-width: 55rem) {
  .search-form {
    display: block;
  }
}

.secondary-nav-container {
  float: right;
  margin-right: 300px;
  margin-bottom: 0;
  display: flex;
  justify-content: right;
  align-items: center;
  height: 100%;
  font-size: var(--s-1);
  position: absolute;
  top: 50%;
  left: 60%;
  transform: translate(-50%, -50%);
}

nav h2 {
  color: var(--color-white);
  font-weight: var(--font-weight-semibold);
  text-transform: uppercase;
  margin-top: 0;
  margin-bottom: 10px;
  font-size: var(--s-1);
}

/* .sec-menu-title {
  margin-top: -15px;
} */

.nav {
  display: flex;
  margin-bottom: 0;
  padding-left: 0;
  list-style: none;
}

.secondary-nav-container ::slotted(a) {
  padding: 5px 6px !important;
  border-right: 1px solid var(--color-white) !important;
  line-height: .8 !important;
  color: var(--color-white) !important;
}
.secondary-nav-container ::slotted(a:first-child) {
  padding-left: 0 !important;
}
.secondary-nav-container ::slotted(a:last-child) {
  border: none !important;
}
.secondary-nav-container ::slotted(a:hover) {
  text-decoration: underline !important;
}

@media (max-width: 55rem) {
  .secondary-nav-container  {
    display: none;
  }
}


